import { Grid } from "@mui/material";
import React from "react";
import Box from "@mui/material/Box";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import CollectionGrid from "./CollectionGrid";

function Collection() {
  const btnStyles = [
    {
      btnDes: " All Items",
      btnClass: "hero_btn",
    },
    {
      btnDes: " Music",
      btnClass: "hero_btn",
    },
    {
      btnDes: " Games",
      btnClass: "hero_btn",
    },
    {
      btnDes: " Art",
      btnClass: "common_btn",
    },
    {
      btnDes: " photography",
      btnClass: "hero_btn",
    },
  ];
  return (
    <div>
      <Grid container justifyContent="center">
        <Grid item xs={11} lg={10}>
          {/* Grid For headings */}
          <div className="seprator"></div>

          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item lg={5}>
              <h1 className="head_h">collection</h1>
            </Grid>
            <Grid item sm={11} lg={7}>
              <ul className="btn_gal">
                {btnStyles.map((e) => {
                  return (
                    <li className="btn_items">
                      <button className={e.btnClass}>{e.btnDes}</button>
                    </li>
                  );
                })}
              </ul>
            </Grid>
          </Grid>
          <div className="seprator"></div>

          {/* Grid for gallery */}
          <CollectionGrid />
        </Grid>
      </Grid>
    </div>
  );
}

export default Collection;
